export default {
    meta: {
        title: '跟进记录',
        url: '/standardstore/franchiseelist',
        urlName: '标准版拓店-加盟商',
    }
};
